/**
 * assets/kits-quickbuy-atc.js
 *
 * Delegated click/keydown handler for .ks-atc-btn (div role="button").
 * Loaded on collection pages so the quick-buy modal ATC works.
 * On product pages kits-product-mobile.js registers the same handler;
 * double-registering is harmless since requestSubmit() is idempotent.
 */
(function () {
  'use strict';

  function triggerAtc(btn) {
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;

    var form = btn.closest('form');
    if (!form) {
      var formId = btn.getAttribute('data-form-id');
      if (formId) form = document.getElementById(formId);
    }
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ks-atc-btn');
    if (btn) triggerAtc(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('.ks-atc-btn');
    if (!btn) return;
    e.preventDefault();
    triggerAtc(btn);
  });
})();
